export const GET_LATEST_NEWS = 'GET_LATEST_NEWS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
